import React, { useEffect, useState } from "react";
import { Loader2, X } from "lucide-react";

const clock = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;

function useElapsed(since) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  return since ? Math.max(0, (now - new Date(since).getTime()) / 1000) : 0;
}

export function ProgressPanel({ job, busy, onCancel }) {
  const rendering = job.status === "rendering";
  const elapsed = useElapsed(job.status === "queued" ? null : job.started_at);
  const done = job.frames_done || 0, total = job.frames_total || 0;
  const pct = job.status === "queued" ? 0 : rendering ? (total ? done / total : 0) : 1;
  const eta = rendering && done > 5 ? (elapsed / done) * (total - done) : null;
  return (
    <div className="space-y-3" data-testid="render3d-progress">
      <div className="flex items-center gap-2 text-sm text-slate-200">
        <Loader2 className="w-4 h-4 animate-spin text-slate-400" />
        <span data-testid="render3d-stage">{job.stage}</span>
      </div>
      <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
        <div className="h-full bg-white transition-[width] duration-700" style={{ width: `${Math.round(pct * 100)}%` }} data-testid="render3d-bar" />
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-slate-500 font-mono">
        {total > 0 && job.status !== "queued" && <span data-testid="render3d-frames">frame {done.toLocaleString()} / {total.toLocaleString()}</span>}
        {elapsed > 0 && <span data-testid="render3d-elapsed">{clock(elapsed)} elapsed</span>}
        {eta != null && <span data-testid="render3d-remaining">~{clock(eta)} left</span>}
      </div>
      <p className="text-[11px] text-slate-500">You can leave this chat. The video keeps rendering and appears here when it's ready.</p>
      {!job.cancel_requested && (
        <button type="button" disabled={busy} onClick={onCancel} data-testid="render3d-cancel"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/15 text-xs text-slate-300 hover:bg-white/10 transition-colors">
          <X className="w-3.5 h-3.5" />Cancel render
        </button>
      )}
    </div>
  );
}
